(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["discount-price-engine"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('discount-price-engine')) {
    const parseCodes = (value) => {
      const map = {};
      String(value || '')
        .split(',')
        .forEach((pair) => {
          const [code, percent] = pair.split(':').map((part) => (part || '').trim());
          const pct = parseFloat(String(percent).replace(',', '.'));
          if (code && pct > 0) map[code.toLowerCase()] = pct;
        });
      return map;
    };

    /* Minimal port of Shopify's money formatting. */
    const formatMoney = (cents, format) => {
      const placeholder = /\{\{\s*(\w+)\s*\}\}/;
      const match = String(format || '').match(placeholder);
      const key = match ? match[1] : 'amount';
      const withDelimiters = (number, precision, thousands, decimal) => {
        const fixed = (number / 100).toFixed(precision);
        const parts = fixed.split('.');
        const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      };
      let value;
      switch (key) {
        case 'amount_no_decimals':
          value = withDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = withDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = withDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = withDelimiters(cents, 2, "'", '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = withDelimiters(cents, 0, ' ', '.');
          break;
        case 'amount_with_space_separator':
          value = withDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_with_period_and_space_separator':
          value = withDelimiters(cents, 2, ' ', '.');
          break;
        default:
          value = withDelimiters(cents, 2, ',', '.');
      }
      return String(format || '{{amount}}').replace(placeholder, value);
    };

    const setLastText = (element, text) => {
      if (!element) return;
      const last = element.lastChild;
      if (last && last.nodeType === Node.TEXT_NODE) {
        last.nodeValue = text;
      } else {
        element.appendChild(document.createTextNode(text));
      }
    };

    class DiscountPriceEngine extends HTMLElement {
      connectedCallback() {
        this.codes = parseCodes(this.dataset.codes);
        this.ownPercentAllCodes = this.dataset.ownPercentAllCodes === 'true';
        const useCurrency = this.dataset.currencyCodeEnabled === 'true';
        this.format = useCurrency
          ? this.dataset.moneyWithCurrencyFormat || this.dataset.moneyFormat
          : this.dataset.moneyFormat;
        this.state = null;

        this._refresh = () => this.refresh();
        this._reapply = () => window.requestAnimationFrame(() => this.applyAll());
        this._onVariantChange = (event) => {
          this.updateFromVariant(event);
          this._reapply();
        };

        ['cart:refresh', 'cart:change', 'cart:updated'].forEach((name) => {
          document.addEventListener(name, this._refresh);
        });
        document.addEventListener('variant:change', this._onVariantChange);
        document.addEventListener('input', (event) => {
          if (event.target && event.target.matches('[data-buy-quantity]')) this._reapply();
        });
        document.addEventListener('change', (event) => {
          if (event.target && event.target.matches('[data-buy-quantity]')) this._reapply();
        });

        /* Cards that arrive later (recommendations, infinite scroll, drawers). */
        this._observer = new MutationObserver((mutations) => {
          if (!this.state) return;
          const relevant = mutations.some((mutation) =>
            Array.from(mutation.addedNodes).some(
              (node) =>
                node.nodeType === Node.ELEMENT_NODE &&
                (node.matches('price-list[data-discount-price]') ||
                  node.querySelector?.('price-list[data-discount-price]'))
            )
          );
          if (relevant) this._reapply();
        });
        this._observer.observe(document.body, { childList: true, subtree: true });

        this.refresh();
      }

      disconnectedCallback() {
        ['cart:refresh', 'cart:change', 'cart:updated'].forEach((name) => {
          document.removeEventListener(name, this._refresh);
        });
        document.removeEventListener('variant:change', this._onVariantChange);
        this._observer?.disconnect();
      }

      async refresh() {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) return;
          const cart = await response.json();
          this.state = this.resolve(cart);
        } catch (error) {
          this.state = null;
        }
        this.applyAll();
      }

      /* Which code is active and how much does it take off? */
      resolve(cart) {
        const codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
        if (!codes.length) return null;

        /* per code: the percentage per cart variant (codes can take different amounts per product,
           e.g. from the variant metafield custom.discount_percentage) */
        const derived = {};
        const inCart = new Set();
        (cart.items || []).forEach((item) => {
          inCart.add(String(item.variant_id));
          (item.line_level_discount_allocations || []).forEach((allocation) => {
            const application = allocation.discount_application;
            if (!application || !application.title) return;
            if (application.value_type === 'percentage') {
              const key = String(application.title).toLowerCase();
              derived[key] = derived[key] || {};
              derived[key][String(item.variant_id)] = parseFloat(application.value);
            }
          });
        });

        /* order-level percentage codes (e.g. DANKE20 = 20% on the whole cart) have no line-level allocations;
           they take the same percentage off every product, so they count for every product */
        const orderWide = {};
        (cart.cart_level_discount_applications || []).forEach((application) => {
          if (!application || !application.title || application.value_type !== 'percentage') return;
          const pct = parseFloat(application.value);
          if (pct > 0 && pct < 100) orderWide[String(application.title).toLowerCase()] = pct;
        });

        for (const entry of codes) {
          const code = String(entry.code || '').trim();
          if (!code) continue;
          const key = code.toLowerCase();
          const active = entry.applicable === true || cart.item_count === 0;
          if (!active) continue;
          if (orderWide[key] > 0) {
            return { code: code, percent: orderWide[key], byVariant: {}, inCart: inCart, known: true, orderWide: true };
          }
          const byVariant = derived[key] || {};
          const cartPercents = Object.values(byVariant);
          /* fallback for products without their own percentage: configured value, else the most common one in the cart */
          let percent = this.codes[key];
          if (!(percent > 0) && cartPercents.length) {
            const counts = {};
            cartPercents.forEach((value) => (counts[value] = (counts[value] || 0) + 1));
            percent = parseFloat(Object.keys(counts).sort((a, b) => counts[b] - counts[a])[0]);
          }
          const known = key in this.codes;
          if (percent > 0 && percent < 100) {
            return { code: code, percent: percent, byVariant: byVariant, inCart: inCart, known: known };
          }
          /* campaign: an unknown code without a usable cart percentage still shows the variants' own percentages */
          if (!known && this.ownPercentAllCodes) {
            return { code: code, percent: 0, byVariant: byVariant, inCart: inCart, known: false };
          }
        }
        return null;
      }

      updateFromVariant(event) {
        const form = event.target;
        const variant = event.detail && event.detail.variant;
        /* getAttribute: product forms contain <input name="id">, which shadows form.id (DOM clobbering) –
           comparing against form.id never matched, so the stored price stayed on the first variant */
        const formId = form && form.getAttribute ? form.getAttribute('id') : '';
        if (!formId || !variant) return;
        document.querySelectorAll('price-list[data-discount-price]').forEach((list) => {
          const sale = list.querySelector('sale-price[form]');
          if (!sale || sale.getAttribute('form') !== formId) return;
          list.dataset.variantId = String(variant.id || '');
          list.dataset.price = String(variant.price || 0);
          list.dataset.comparePrice = String(variant.compare_at_price || 0);
          /* the variant's own percentage (metafield) – variants differ, e.g. One Whey Neutral */
          if (list.dataset.variantPercents) {
            try {
              const own = parseFloat(JSON.parse(list.dataset.variantPercents)[String(variant.id)]);
              if (own > 0) list.dataset.discountPercent = String(own);
              else delete list.dataset.discountPercent;
            } catch (error) {
              /* keep the current percentage */
            }
          }
          if (variant.unit_price) {
            list.dataset.unitPrice = String(variant.unit_price);
            const measurement = variant.unit_price_measurement || {};
            const reference =
              measurement.reference_value && measurement.reference_value !== 1
                ? measurement.reference_value
                : '';
            list.dataset.unitRef = `${reference}${measurement.reference_unit || ''}`;
          } else {
            delete list.dataset.unitPrice;
          }
        });
      }

      applyAll() {
        document
          .querySelectorAll('price-list[data-discount-price]')
          .forEach((list) => this.applyPriceList(list));
        this.applyBuyButtons();
        document.dispatchEvent(new CustomEvent('discount-price:applied'));
      }

      /* Order: what the cart actually takes off this variant → nothing if the variant is in the cart
         unreduced or the product is excluded in the theme settings → unknown code: the variant's own
         percentage only in campaign mode (else nothing, it may be limited to some products) → the variant's
         own percentage (metafield custom.discount_percentage) → the code's general percentage. */
      percentFor(list) {
        if (!this.state) return 0;
        if (this.state.orderWide) return this.state.percent;
        const variantId = list.dataset.variantId;
        const fromCart = this.state.byVariant && this.state.byVariant[variantId];
        if (fromCart > 0) return fromCart;
        if (this.state.inCart?.has(variantId)) return 0;
        if (list.hasAttribute('data-discount-excluded')) return 0;
        const override = parseFloat(list.dataset.discountPercent);
        const hasOverride = override > 0 && override < 100;
        if (!this.state.known) return this.ownPercentAllCodes && hasOverride ? override : 0;
        if (hasOverride) return override;
        return this.state.percent;
      }

      applyPriceList(list) {
        const price = parseInt(list.dataset.price, 10) || 0;
        const compare = parseInt(list.dataset.comparePrice, 10) || 0;
        const sale = list.querySelector('sale-price');
        if (!sale || price <= 0) return;

        /* "ab €15,90" cards (variants with different prices): keep the translated "ab" around the amount */
        const formatSale = (cents) =>
          `${list.dataset.priceFrom || ''}${formatMoney(cents, this.format)}${list.dataset.priceFromSuffix || ''}`;

        let compareEl = list.querySelector('compare-at-price');
        const active = Boolean(this.state);
        const percent = active ? this.percentFor(list) : 0;

        if (active && percent > 0) {
          const reduced = Math.round(price * (1 - percent / 100));
          const saving = price - reduced;

          setLastText(sale, formatSale(reduced));
          sale.classList.add('text-on-sale');

          if (!compareEl) {
            compareEl = document.createElement('compare-at-price');
            compareEl.className = 'text-subdued line-through';
            sale.insertAdjacentElement('afterend', compareEl);
          }
          setLastText(compareEl, formatMoney(price, this.format));
          compareEl.hidden = false;

          const pctLabel = Number.isInteger(percent) ? percent : percent.toFixed(1).replace('.', ',');
          const codeLabel = `-${pctLabel}% <span>${this.state.code.toUpperCase()}</span>`;
          this.applyCodeBadge(list, codeLabel, `-${pctLabel}%`);

          /* Champions Week deal list only: chips under the price ("-20% EVO", "-€3,69"); on the product page the
             code badge above the title shows the code, product cards only the percentage */
          if (list.closest('.evo-dl')) {
            let chips = list.querySelector('.discount-price__chips');
            if (!chips) {
              chips = document.createElement('span');
              chips.className = 'discount-price__chips';
              chips.innerHTML =
                '<span class="discount-price__chip discount-price__chip--code" data-chip-code></span>' +
                '<span class="discount-price__chip discount-price__chip--amount" data-chip-amount></span>';
              list.appendChild(chips);
            }
            chips.querySelector('[data-chip-code]').innerHTML = codeLabel;
            chips.querySelector('[data-chip-amount]').textContent = `-${formatMoney(saving, this.format)}`;
          }

          list.setAttribute('data-discount-active', '');
          this.applyMeta(list, reduced, percent, price);
        } else {
          setLastText(sale, formatSale(price));
          sale.classList.toggle('text-on-sale', compare > price);
          if (compareEl) {
            if (compare > price) {
              setLastText(compareEl, formatMoney(compare, this.format));
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
          list.querySelector('.discount-price__chips')?.remove();
          this.applyCodeBadge(list, '', '');
          list.removeAttribute('data-discount-active');
          this.applyMeta(list, price, 0, compare > price ? compare : 0);
        }
      }

      /* Code badge in the badge list, filled from the first price list there (the product page's main price); hidden
         without a code. Product page: "-20% EVO"; product card (data-code-badge-plain, only cards without their own
         "-25%" badge): "-20%". A card's quick-buy drawer holds a product page of its own, so its badges are skipped. */
      applyCodeBadge(list, html, plain) {
        const scope = '.product-info, product-card';
        const host = list.closest(scope);
        const own = (element) => element.closest(scope) === host;
        if (!host || Array.from(host.querySelectorAll('price-list[data-discount-price]')).find(own) !== list) return;
        host.querySelectorAll('[data-code-badge]').forEach((badge) => {
          if (!own(badge)) return;
          const text = badge.hasAttribute('data-code-badge-plain') ? plain : html;
          badge.querySelector('[data-code-badge-text]').innerHTML = text;
          badge.hidden = !text;
        });
      }

      /* Product page only: €/kg and €/Riegel next to the big price. referencePrice = the struck-through price
         (normal price while a code is active, else the compare-at price), shown per piece as well. */
      applyMeta(list, effectivePrice, percent, referencePrice) {
        const scope = list.closest('.product-info__price');
        if (!scope) {
          /* product cards: the unit price sits inside the price list as "(€55,44/kg)" – reduce it too */
          const cardUnit = list.querySelector('unit-price');
          const cardUnitPrice = parseInt(list.dataset.unitPrice, 10) || 0;
          if (cardUnit && cardUnitPrice > 0) {
            const reducedUnit = Math.round(cardUnitPrice * (1 - percent / 100));
            const text = `${formatMoney(reducedUnit, this.format)}/${list.dataset.unitRef || ''}`;
            setLastText(cardUnit, cardUnit.textContent.trim().startsWith('(') ? `(${text})` : text);
          }
          return;
        }

        const unit = scope.querySelector('unit-price');
        const unitPrice = parseInt(list.dataset.unitPrice, 10) || 0;
        if (unit && unitPrice > 0) {
          const reducedUnit = Math.round(unitPrice * (1 - percent / 100));
          unit.textContent = `${formatMoney(reducedUnit, this.format)}/${list.dataset.unitRef || ''}`;
        }

        const perUnit = scope.querySelector('per-unit-price [data-per-unit-amount]');
        const count = parseFloat(scope.querySelector('per-unit-price')?.dataset.count) || 0;
        if (perUnit && count >= 1) {
          const perUnitPrice = Math.round(effectivePrice / count);
          const perUnitCompare = referencePrice > effectivePrice ? Math.round(referencePrice / count) : 0;
          perUnit.textContent = formatMoney(perUnitPrice, this.format);
          const compareEl = scope.querySelector('per-unit-price [data-per-unit-compare]');
          if (compareEl) {
            compareEl.querySelector('[data-per-unit-compare-amount]').textContent = formatMoney(perUnitCompare, this.format);
            compareEl.hidden = perUnitCompare <= perUnitPrice;
          }
        }
      }

      applyBuyButtons() {
        document.querySelectorAll('buy-buttons[form]').forEach((buyButtons) => {
          const priceEl = buyButtons.querySelector('[data-buy-button-price]');
          if (!priceEl) return;
          const list = Array.from(document.querySelectorAll('price-list[data-discount-price]')).find(
            (candidate) =>
              candidate.querySelector('sale-price[form]')?.getAttribute('form') === buyButtons.getAttribute('form')
          );
          if (!list) return;
          const price = parseInt(list.dataset.price, 10) || 0;
          if (price <= 0) return;
          const percent = this.state ? this.percentFor(list) : 0;
          const quantityInput = buyButtons.querySelector('[data-buy-quantity]');
          const quantity =
            quantityInput && quantityInput.validity.valid && quantityInput.valueAsNumber > 0
              ? quantityInput.valueAsNumber
              : 1;
          const unit = percent > 0 ? Math.round(price * (1 - percent / 100)) : price;
          priceEl.textContent = formatMoney(unit * quantity, this.format);
        });
      }
    }

    window.customElements.define('discount-price-engine', DiscountPriceEngine);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evo-cart-toast"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__evoCartToast) return;
    window.__evoCartToast = true;

    var HIDE_MS = 3200;
    var BUTTON_MS = 2200;
    var CHECK_SVG =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    var ERROR_SVG =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M12 6v7M12 17.5v.5"/></svg>';
    var CLOSE_SVG =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

    var toast = null;
    var hideTimer = 0;
    var paused = false;

    function cartRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function buildToast() {
      toast = document.createElement('div');
      toast.className = 'evo-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML =
        '<span class="evo-toast__icon" aria-hidden="true"></span>' +
        '<div class="evo-toast__body">' +
        '<p class="evo-toast__title"></p>' +
        '<a class="evo-toast__link" href="' + cartRoot() + 'cart" data-no-instant>Zum Warenkorb</a>' +
        '</div>' +
        '<button type="button" class="evo-toast__close" aria-label="Schließen">' + CLOSE_SVG + '</button>';
      document.body.appendChild(toast);

      toast.querySelector('.evo-toast__close').addEventListener('click', hideToast);
      // the cart drawer opens through its own delegated [aria-controls] handler – we only close the toast
      toast.querySelector('.evo-toast__link').addEventListener('click', function () {
        hideToast();
      });
      toast.addEventListener('mouseenter', function () {
        paused = true;
        clearTimeout(hideTimer);
      });
      toast.addEventListener('mouseleave', function () {
        paused = false;
        scheduleHide(1500);
      });
      toast.addEventListener('focusin', function () {
        paused = true;
        clearTimeout(hideTimer);
      });
      toast.addEventListener('focusout', function () {
        paused = false;
        scheduleHide(1500);
      });
    }

    function scheduleHide(ms) {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        if (!paused) hideToast();
      }, ms);
    }

    function hideToast() {
      clearTimeout(hideTimer);
      if (toast) toast.classList.remove('is-visible');
    }

    // phones: top edge of the screen; desktop: right under the header
    function positionToast() {
      var top = 12;
      if (window.matchMedia('(min-width: 700px)').matches) {
        var header = document.querySelector('store-header') || document.querySelector('header');
        var bottom = header ? header.getBoundingClientRect().bottom : 0;
        top = Math.max(16, Math.round(bottom) + 12);
      }
      toast.style.setProperty('--evo-toast-top', top + 'px');
    }

    function showToast(message, isError) {
      if (!toast) buildToast();

      var cartDrawer = document.getElementById('cart-drawer');
      var link = toast.querySelector('.evo-toast__link');
      var drawerCart = cartDrawer && window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'drawer';
      if (drawerCart) link.setAttribute('aria-controls', 'cart-drawer');
      else link.removeAttribute('aria-controls');

      toast.classList.toggle('evo-toast--error', !!isError);
      toast.querySelector('.evo-toast__icon').innerHTML = isError ? ERROR_SVG : CHECK_SVG;
      toast.querySelector('.evo-toast__title').textContent = message;
      positionToast();

      paused = toast.matches(':hover');
      // restart the entrance when a second product is added while the toast is still there
      toast.classList.remove('is-visible');
      void toast.offsetWidth;
      toast.classList.add('is-visible');
      scheduleHide(isError ? HIDE_MS + 1500 : HIDE_MS);
    }

    function markAdded(button) {
      if (!button) return;
      button.classList.add('is-added');
      if (!button.querySelector('.evo-quick-add__check')) {
        button.insertAdjacentHTML('beforeend', '<div class="evo-quick-add__check" aria-hidden="true">' + CHECK_SVG + '</div>');
      }
      clearTimeout(button.__evoAddedTimer);
      button.__evoAddedTimer = setTimeout(function () {
        button.classList.remove('is-added');
        var check = button.querySelector('.evo-quick-add__check');
        if (check) check.remove();
      }, BUTTON_MS);
    }

    // The quick-buy drawer moves to <body> while open, so remember which card button opened it. (Collections that show
    // one card per variant render several cards of the same product with the same drawer id – controls[0] would be
    // the wrong card.)
    var lastQuickBuyButton = null;
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target && event.target.closest ? event.target.closest('.product-card__mobile-quick-buy-button') : null;
        if (button) lastQuickBuyButton = button;
      },
      true
    );

    // the card (or its quick-buy drawer) the form belongs to
    function cardContext(target) {
      if (!target || !target.closest) return null;
      var drawer = target.closest('quick-buy-drawer');
      var card = target.closest('product-card');
      if (!drawer && !card) return null;
      var button = null;
      if (drawer) {
        button = lastQuickBuyButton && lastQuickBuyButton.isConnected ? lastQuickBuyButton : (drawer.controls || [])[0] || null;
      } else {
        button = card.querySelector('.product-card__mobile-quick-buy-button');
      }
      return { drawer: drawer, button: button };
    }

    // capture phase on document: runs before CartDrawer's (bubble) listener and before the quick-buy drawer's own
    document.addEventListener(
      'variant:add',
      function (event) {
        var context = cardContext(event.target);
        if (!context) return;

        if (event.detail) event.detail.blockCartDrawerOpening = true;

        if (context.drawer) {
          // no "added" panel inside the drawer: close it and show the toast. cart:change (separate event) still
          // updates the cart count and the cart drawer content.
          event.stopPropagation();
          setTimeout(function () {
            // every open quick-buy drawer: same-product cards share one drawer id and all open together
            document.querySelectorAll('quick-buy-drawer[open]').forEach(function (drawer) {
              if (typeof drawer.hide === 'function') drawer.hide();
            });
          }, 120);
        }

        markAdded(context.button);
        showToast('Produkt wurde hinzugefügt', false);
      },
      true
    );

    document.addEventListener(
      'cart:error',
      function (event) {
        if (!cardContext(event.target)) return;
        var message = event.detail && event.detail.error;
        showToast(message || 'Das Produkt konnte nicht hinzugefügt werden.', true);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-delivery-timeline"] && !Shopify.designMode) return;
  try {
    /*
    EvoDelivery – pure date logic for the delivery estimate. Used by <delivery-timeline> on the product page
    and in the cart drawer line items (snippets/line-item.liquid), so both always show the same dates.
    All dates are civil dates in the shop timezone ({ y, mo, d }); nothing depends on the visitor's clock zone.
  */
  if (!window.EvoDelivery) {
    window.EvoDelivery = (() => {
      const DEFAULTS = {
        timezone: 'Europe/Berlin',
        cutoffHour: 19,
        shipMin: 0,
        shipMax: 0,
        deliverMin: 1,
        deliverMax: 2,
        businessDays: true,
        saturdayDelivery: true,
        skipHolidays: true,
      };
      const partsFormatters = {};
      const holidayCache = {};

      const dayKey = (date) => date.y * 10000 + date.mo * 100 + date.d;
      const toUtcNoon = (date) => new Date(Date.UTC(date.y, date.mo - 1, date.d, 12));
      const weekday = (date) => toUtcNoon(date).getUTCDay(); // 0 = Sunday … 6 = Saturday

      function addCalendarDays(date, days) {
        const next = new Date(Date.UTC(date.y, date.mo - 1, date.d + days, 12));
        return { y: next.getUTCFullYear(), mo: next.getUTCMonth() + 1, d: next.getUTCDate() };
      }

      // Easter Sunday (Gregorian calendar, anonymous algorithm / Meeus–Jones–Butcher)
      function easterSunday(y) {
        const a = y % 19;
        const b = Math.floor(y / 100);
        const c = y % 100;
        const d = Math.floor(b / 4);
        const e = b % 4;
        const f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3);
        const h = (19 * a + b - d - g + 15) % 30;
        const i = Math.floor(c / 4);
        const k = c % 4;
        const l = (32 + 2 * e + 2 * i - h - k) % 7;
        const m = Math.floor((a + 11 * h + 22 * l) / 451);
        const n = h + l - 7 * m + 114;
        return { y, mo: Math.floor(n / 31), d: (n % 31) + 1 };
      }

      // Nationwide German public holidays: New Year, Good Friday, Easter Monday, 1 May, Ascension,
      // Whit Monday, German Unity Day, Christmas Day, Boxing Day.
      function holidays(y) {
        if (!holidayCache[y]) {
          const fixed = [[1, 1], [5, 1], [10, 3], [12, 25], [12, 26]].map(([mo, d]) => dayKey({ y, mo, d }));
          const easter = easterSunday(y);
          const movable = [-2, 1, 39, 50].map((offset) => dayKey(addCalendarDays(easter, offset)));
          holidayCache[y] = new Set(fixed.concat(movable));
        }
        return holidayCache[y];
      }

      const isHoliday = (date) => holidays(date.y).has(dayKey(date));

      function zoneParts(date, timezone) {
        if (!partsFormatters[timezone]) {
          partsFormatters[timezone] = new Intl.DateTimeFormat('en-CA', {
            timeZone: timezone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hourCycle: 'h23',
          });
        }
        const map = {};
        partsFormatters[timezone].formatToParts(date).forEach((part) => {
          map[part.type] = part.value;
        });
        return {
          y: Number(map.year),
          mo: Number(map.month),
          d: Number(map.day),
          h: Number(map.hour) % 24,
          mi: Number(map.minute),
          s: Number(map.second),
        };
      }

      // Wall-clock time in `timezone` -> UTC timestamp (handles DST via the zone's offset at that moment)
      function civilToUtc(date, hour, timezone) {
        const guess = Date.UTC(date.y, date.mo - 1, date.d, hour, 0, 0);
        const shown = zoneParts(new Date(guess), timezone);
        const shownUtc = Date.UTC(shown.y, shown.mo - 1, shown.d, shown.h, shown.mi, shown.s);
        return guess - (shownUtc - guess);
      }

      // Move forward `count` days that satisfy `accept` (count 0 = the start day itself)
      function advance(start, count, accept) {
        let current = start;
        let left = Math.max(0, count);
        while (left > 0) {
          current = addCalendarDays(current, 1);
          if (accept(current)) left -= 1;
        }
        return current;
      }

      function estimate(now, overrides) {
        const o = Object.assign({}, DEFAULTS, overrides || {});
        const shipMax = Math.max(o.shipMin, o.shipMax);
        const deliverMax = Math.max(o.deliverMin, o.deliverMax);
        const holidayOff = (date) => o.skipHolidays && isHoliday(date);

        const isShipDay = (date) => {
          if (!o.businessDays) return true;
          const day = weekday(date);
          return day >= 1 && day <= 5 && !holidayOff(date);
        };
        const isDeliveryDay = (date) => {
          if (!o.businessDays) return true;
          const day = weekday(date);
          return (day >= 1 && day <= 5 || (day === 6 && o.saturdayDelivery)) && !holidayOff(date);
        };

        const zoneNow = zoneParts(now, o.timezone);
        const today = { y: zoneNow.y, mo: zoneNow.mo, d: zoneNow.d };
        let shipDay = today;
        if (!isShipDay(today) || zoneNow.h >= o.cutoffHour) shipDay = advance(today, 1, isShipDay);

        return {
          today,
          shipDay,
          cutoff: new Date(civilToUtc(shipDay, o.cutoffHour, o.timezone)),
          shippedFrom: advance(shipDay, o.shipMin, isShipDay),
          shippedTo: advance(shipDay, shipMax, isShipDay),
          deliveredFrom: advance(shipDay, o.deliverMin, isDeliveryDay),
          deliveredTo: advance(shipDay, deliverMax, isDeliveryDay),
        };
      }

      const sameDay = (a, b) => dayKey(a) === dayKey(b);

      // "Sa., 26. Sept. – Mo., 28. Sept."
      function formatDeliveryRange(from, to, locale) {
        const formatter = new Intl.DateTimeFormat(locale || 'de', {
          timeZone: 'UTC',
          weekday: 'short',
          day: 'numeric',
          month: 'short',
        });
        const start = formatter.format(toUtcNoon(from));
        return sameDay(from, to) ? start : start + ' – ' + formatter.format(toUtcNoon(to));
      }

      // "26. – 28. September" / "30. September – 1. Oktober" (steps graphic)
      function formatRange(from, to, locale) {
        const long = (date, options) => toUtcNoon(date).toLocaleDateString(locale || 'de', Object.assign({ timeZone: 'UTC' }, options));
        if (sameDay(from, to)) return long(from, { day: 'numeric', month: 'long' });
        if (from.y === to.y && from.mo === to.mo) return from.d + '. – ' + to.d + '. ' + long(from, { month: 'long' });
        return long(from, { day: 'numeric', month: 'long' }) + ' – ' + long(to, { day: 'numeric', month: 'long' });
      }

      return { DEFAULTS, estimate, isHoliday, easterSunday, formatDeliveryRange, formatRange, zoneParts };
    })();
  }

  if (!window.customElements.get('delivery-timeline')) {
    class DeliveryTimeline extends HTMLElement {
      connectedCallback() {
        if (this.timer) return;
        this.setAttribute('data-ready', '');
        this.countdownEl = this.querySelector('[data-countdown]');
        this.estimatedDeliveryEl = this.querySelector('[data-estimated-delivery]');
        this.orderedEl = this.querySelector('[data-ordered]');
        this.shippedEl = this.querySelector('[data-shipped]');
        this.deliveredEl = this.querySelector('[data-delivered]');
        this.locale = this.dataset.locale || 'de';

        const defaults = window.EvoDelivery.DEFAULTS;
        const int = (value, fallback) => {
          const parsed = parseInt(value, 10);
          return Number.isFinite(parsed) ? parsed : fallback;
        };
        this.options = {
          timezone: this.dataset.timezone || defaults.timezone,
          cutoffHour: int(this.dataset.cutoffHour, defaults.cutoffHour),
          shipMin: int(this.dataset.shipMin, defaults.shipMin),
          shipMax: int(this.dataset.shipMax, defaults.shipMax),
          deliverMin: int(this.dataset.deliverMin, defaults.deliverMin),
          deliverMax: int(this.dataset.deliverMax, defaults.deliverMax),
          businessDays: this.dataset.businessDays !== 'false',
          saturdayDelivery: this.dataset.saturdayDelivery !== 'false',
          skipHolidays: this.dataset.skipHolidays !== 'false',
        };

        this.tick = this.tick.bind(this);
        this.tick();
        // the cart line items have no countdown: refresh once a minute so the dates roll over at the cutoff
        this.timer = window.setInterval(this.tick, this.countdownEl ? 1000 : 60000);
      }

      disconnectedCallback() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      pad(value) {
        return String(value).padStart(2, '0');
      }

      renderCountdown(cutoff, now) {
        const remaining = Math.max(0, Math.ceil((cutoff.getTime() - now.getTime()) / 1000));
        const hours = Math.floor(remaining / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;
        let text = this.pad(minutes) + ':' + this.pad(seconds);
        if (hours >= 24) {
          // Weekend / after cutoff on Friday: "62 Std. 05 Min." reads better than a 62-hour clock
          text = hours + ' ' + (this.dataset.labelHours || 'Std.') + ' ' + this.pad(minutes) + ' ' + (this.dataset.labelMinutes || 'Min.');
        } else if (hours > 0) {
          text = this.pad(hours) + ':' + text;
        }
        this.countdownEl.textContent = text;
        this.countdownEl.dateTime = 'PT' + hours + 'H' + minutes + 'M' + seconds + 'S';
      }

      tick() {
        const now = new Date();
        const result = window.EvoDelivery.estimate(now, this.options);
        const { formatDeliveryRange, formatRange } = window.EvoDelivery;

        if (this.countdownEl) this.renderCountdown(result.cutoff, now);
        if (this.estimatedDeliveryEl) {
          this.estimatedDeliveryEl.textContent = formatDeliveryRange(result.deliveredFrom, result.deliveredTo, this.locale);
        }
        if (this.orderedEl && this.dataset.labelToday) this.orderedEl.textContent = this.dataset.labelToday;
        if (this.shippedEl) this.shippedEl.textContent = formatRange(result.shippedFrom, result.shippedTo, this.locale);
        if (this.deliveredEl) this.deliveredEl.textContent = formatRange(result.deliveredFrom, result.deliveredTo, this.locale);
      }
    }

    window.customElements.define('delivery-timeline', DeliveryTimeline);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-video"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('product-gallery-video')) {
    class ProductGalleryVideo extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.frame = this.querySelector('[data-video-frame]');
        this.player = this.frame ? this.frame.querySelector('video') : null;
        this.embedTemplate = this.querySelector('[data-video-embed]');
        this.preview = this.querySelector('[data-video-preview]');
        this.openButton = this.querySelector('[data-video-open]');

        this.onOpen = this.open.bind(this);
        this.onClose = this.close.bind(this);
        this.onDialogClick = this.handleDialogClick.bind(this);
        this.onDialogClosed = this.handleDialogClosed.bind(this);

        if (this.openButton) this.openButton.addEventListener('click', this.onOpen);
        if (this.dialog) {
          this.dialog.querySelectorAll('[data-video-close]').forEach((button) => {
            button.addEventListener('click', this.onClose);
          });
          this.dialog.addEventListener('click', this.onDialogClick);
          this.dialog.addEventListener('close', this.onDialogClosed);
        }

        this.setupPreview();
      }

      disconnectedCallback() {
        if (this.previewObserver) this.previewObserver.disconnect();
        if (this.dialog && this.dialog.open) this.dialog.close();
      }

      /* muted loop inside the bubble – only while visible and when motion / data saving allow it */
      setupPreview() {
        if (!this.preview) return;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const saveData = navigator.connection && navigator.connection.saveData;
        if (reduceMotion || saveData || !('IntersectionObserver' in window)) return;

        this.previewObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.dialog.open) {
              this.playPreview();
            } else {
              this.pausePreview();
            }
          });
        }, { threshold: 0.4 });
        this.previewObserver.observe(this);
      }

      playPreview() {
        if (!this.preview) return;
        const promise = this.preview.play();
        if (promise && promise.then) {
          promise.then(() => this.preview.classList.add('is-playing')).catch(() => {});
        } else {
          this.preview.classList.add('is-playing');
        }
      }

      pausePreview() {
        if (!this.preview) return;
        this.preview.pause();
      }

      open(event) {
        if (event) event.preventDefault();
        if (!this.dialog || this.dialog.open) return;

        this.pausePreview();
        this.pauseGalleryMedia();

        if (this.embedTemplate && this.frame) {
          this.frame.appendChild(this.embedTemplate.content.cloneNode(true));
        }

        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
        document.documentElement.classList.add('lock');

        if (this.player) {
          if (this.player.dataset.poster && !this.player.getAttribute('poster')) {
            this.player.setAttribute('poster', this.player.dataset.poster);
          }
          this.player.currentTime = 0;
          const promise = this.player.play();
          if (promise && promise.catch) promise.catch(() => {});
        }
      }

      close(event) {
        if (event) event.preventDefault();
        if (!this.dialog) return;
        if (this.dialog.open && typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
          this.handleDialogClosed();
        }
      }

      /* click on the backdrop (outside the frame) closes the lightbox */
      handleDialogClick(event) {
        if (event.target === this.dialog) this.close();
      }

      handleDialogClosed() {
        document.documentElement.classList.remove('lock');
        if (this.player) {
          this.player.pause();
          this.player.currentTime = 0;
        }
        if (this.frame) {
          this.frame.querySelectorAll('iframe').forEach((iframe) => iframe.remove());
        }
        if (this.openButton) this.openButton.focus({ preventScroll: true });
        this.playPreview();
      }

      /* stop autoplaying gallery videos so two audio tracks never overlap */
      pauseGalleryMedia() {
        const gallery = this.closest('product-gallery');
        if (!gallery) return;
        gallery.querySelectorAll('video-media, model-media').forEach((media) => {
          if (typeof media.pause === 'function') media.pause();
        });
      }
    }

    window.customElements.define('product-gallery-video', ProductGalleryVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-nutrition-label"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('nutrition-facts')) {
    const clean = (value) =>
      (value || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim();

    const normalize = (value) =>
      clean(value)
        .toLowerCase()
        .replace(/[^a-z0-9äöüß]+/g, '');

    class NutritionFacts extends HTMLElement {
      connectedCallback() {
        if (!this._built) {
          this._built = true;
          this.build();
        }
        /* The element can be moved in the DOM after load (disconnect + reconnect), so listeners are re-bound on every connect. */
        this.listen();
      }

      disconnectedCallback() {
        if (this._onVariantChange) {
          document.removeEventListener('variant:change', this._onVariantChange);
        }
      }

      build() {
        this.source = this.querySelector('[data-nutrition-source]');
        if (!this.source) return;

        const parsed = this.parseSource(this.source);
        if (!parsed.groups.length) return;
        this.sortByOptions(parsed.groups, this.getAttribute('data-option-order'));

        this.groups = parsed.groups;
        this.ingredientsSource = this.querySelector('[data-ingredients-source]');
        const ingredients = this.ingredientsSource
          ? this.parseIngredients(this.ingredientsSource)
          : { groups: [], notes: [] };
        this.render(parsed, ingredients);
        this.source.hidden = true;
        if (this.ingredientsSource && ingredients.groups.length) this.ingredientsSource.hidden = true;

        this.selectByOptions(this.getAttribute('data-selected-options'));

        this._onVariantChange = (event) => {
          const variant = event.detail && event.detail.variant;
          if (!variant) return;
          this.selectByOptions((variant.options || []).join('||'), 'smooth');
        };
      }

      listen() {
        if (this._onVariantChange) document.addEventListener('variant:change', this._onVariantChange);
      }

      /* Puts the flavour tabs in the order of the variant picker (product option values, admin order), so the page
         can keep its own order (Mixed Box cuts the EVOBAR pages after a fixed heading). Flavours without a matching
         option value stay behind in page order; with fewer than two matches nothing moves. */
      sortByOptions(groups, optionsValue) {
        const values = (optionsValue || '').split('||').map(normalize).filter(Boolean);
        if (!values.length) return;

        const rank = (group) => {
          const flavour = normalize(group.label);
          if (!flavour) return -1;
          const exact = values.indexOf(flavour);
          if (exact > -1) return exact;
          return values.findIndex(
            (value) => value.length > 2 && (value.indexOf(flavour) !== -1 || flavour.indexOf(value) !== -1)
          );
        };

        const ranked = groups.map((group, index) => ({ group: group, index: index, rank: rank(group) }));
        if (ranked.filter((entry) => entry.rank > -1).length < 2) return;

        const order = (entry) => (entry.rank > -1 ? entry.rank : values.length);
        ranked.sort((a, b) => order(a) - order(b) || a.index - b.index);
        ranked.forEach((entry, i) => {
          groups[i] = entry.group;
        });
      }

      /* Splits the rich-text source into one group per flavour: "Nährwerte <flavour>" + table, plus extra tables
         under other headings ("Aminosäurenprofil <flavour>") or without a heading, which belong to the same flavour.
         Every flavour becomes exactly one tab; the extra tables get their heading as sub-title in that tab. */
      parseSource(source) {
        const groups = [];
        const notes = [];
        let label = null; /* flavour from the last "Nährwerte <flavour>" heading, waiting for its table */
        let extra = null; /* { title, flavour } from another heading, waiting for its table */
        const find = (name) => groups.find((group) => normalize(group.label) === normalize(name));

        /* tables can sit in (nested) wrapper divs, e.g. <div class="overflow-x-auto"><table>…</table><p>*note</p></div>,
           sometimes with the next flavours inside: unwrap them recursively so headings, tables and notes are siblings */
        const elements = [];
        const flatten = (parent) => {
          Array.from(parent.children).forEach((element) => {
            if (element.tagName !== 'TABLE' && element.querySelector('table')) flatten(element);
            else elements.push(element);
          });
        };
        flatten(source);

        elements.forEach((element, index) => {
          if (element.tagName === 'TABLE') {
            if (extra) {
              const target = (extra.flavour && find(extra.flavour)) || groups[groups.length - 1];
              if (target) target.tables.push({ table: element, title: extra.title });
              else groups.push({ label: extra.flavour || '', tables: [{ table: element, title: extra.title }] });
            } else if (label !== null) {
              const existing = label && find(label);
              if (existing) existing.tables.push({ table: element, title: 'Nährwerte' });
              else groups.push({ label: label, tables: [{ table: element, title: 'Nährwerte' }] });
            } else if (groups.length) {
              /* table without its own heading right after a flavour: same flavour */
              groups[groups.length - 1].tables.push({ table: element, title: '' });
            } else {
              groups.push({ label: '', tables: [{ table: element, title: 'Nährwerte' }] });
            }
            label = null;
            extra = null;
            return;
          }

          const text = clean(element.textContent);
          if (!text) return;

          const match = text.match(/^n[äa]hrwert(?:e|en|tabelle)?\s*[:\-–]?\s*(.+?)\s*:?$/i);
          if (match && match[1] && match[1].length <= 60) {
            label = match[1];
            extra = null;
            return;
          }

          if (/^n[äa]hrwert(?:e|en|tabelle)?\s*:?$/i.test(text)) {
            label = '';
            extra = null;
            return;
          }

          /* other short bold heading directly before a table, e.g. "Aminosäurenprofil Lemon Ice Tea" */
          const next = elements[index + 1];
          if (next && next.tagName === 'TABLE' && text.length <= 80 && element.querySelector('strong, b') !== null) {
            const known = groups.find((group) => group.label && normalize(text).endsWith(normalize(group.label)));
            const flavour = known ? known.label : '';
            const title = flavour ? text.slice(0, text.length - flavour.length).replace(/[\s:\-–]+$/, '') : text.replace(/:$/, '');
            extra = { title: title || text, flavour: flavour };
            return;
          }

          /* the same footnote under every flavour table (One Whey: "*Der Salzgehalt …" ten times) shows once */
          if (!notes.some((note) => clean(note.textContent) === text)) notes.push(element.cloneNode(true));
        });

        const labelled = groups.filter((group) => group.label);
        /* No flavour headings: show every table in one panel. */
        if (!labelled.length && groups.length > 1) {
          return {
            groups: [{ label: '', tables: groups.flatMap((group) => group.tables) }],
            notes: notes,
          };
        }

        return { groups: groups, notes: notes };
      }

      /* Splits the ingredients rich text into "Zutaten <flavour>: …" paragraphs + general notes. */
      parseIngredients(source) {
        const groups = [];
        const notes = [];

        Array.from(source.children).forEach((element) => {
          const text = clean(element.textContent);
          if (!text) return;

          let label = null;
          if (/^zutaten\s*:/i.test(text)) {
            label = '';
          } else {
            const match = text.match(/^zutaten\s+([^:]{1,60}?)\s*:/i);
            if (match) label = match[1];
          }

          if (label === null) {
            if (!notes.some((note) => clean(note.textContent) === text)) notes.push(element.cloneNode(true));
            return;
          }

          const clone = element.cloneNode(true);
          clone.querySelectorAll('meta').forEach((meta) => meta.remove());
          this.stripLeadingLabel(clone);
          groups.push({ label: label, element: clone });
        });

        return { groups: groups, notes: notes };
      }

      /* Removes the "Zutaten <flavour>:" prefix from the first text node, keeping allergen markup. */
      stripLeadingLabel(node) {
        const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
        let current = walker.nextNode();
        while (current) {
          if (current.data.trim()) {
            current.data = current.data.replace(/^\s*zutaten(\s+[^:]{1,60}?)?\s*:\s*/i, '');
            return;
          }
          current = walker.nextNode();
        }
      }

      ingredientsFor(group, ingredients) {
        if (!ingredients.groups.length) return [];
        const key = normalize(group.label);
        if (!key) {
          /* single unlabelled nutrition panel: show everything */
          return ingredients.groups;
        }
        const exact = ingredients.groups.filter((entry) => normalize(entry.label) === key);
        if (exact.length) return exact;
        const similar = ingredients.groups.filter((entry) => {
          const other = normalize(entry.label);
          return other && (other.includes(key) || key.includes(other));
        });
        if (similar.length) return similar;
        /* plain "Zutaten: …" without a flavour belongs to every panel (e.g. "Nährwerttabelle Kreatin Monohydrat") */
        return ingredients.groups.filter((entry) => !normalize(entry.label));
      }

      appendIngredients(panel, group, ingredients) {
        const matches = this.ingredientsFor(group, ingredients);
        if (!matches.length) return;

        const wrap = document.createElement('div');
        wrap.className = 'prose nutrition-facts__ingredients';

        const title = document.createElement('h4');
        title.className = 'nutrition-facts__ingredients-title';
        title.textContent = 'Zutaten';
        wrap.appendChild(title);

        matches.forEach((entry) => {
          if (matches.length > 1 && entry.label) {
            const label = document.createElement('p');
            label.innerHTML = '<strong>' + entry.label + ':</strong>';
            wrap.appendChild(label);
          }
          wrap.appendChild(entry.element.cloneNode(true));
        });

        panel.appendChild(wrap);
      }

      render(parsed, ingredients) {
        ingredients = ingredients || { groups: [], notes: [] };
        const productTitle = this.getAttribute('data-product-title') || '';
        const showTabs = parsed.groups.length > 1;

        if (showTabs) {
          this.tabList = document.createElement('div');
          this.tabList.className = 'nutrition-facts__tabs';
          this.tabList.setAttribute('role', 'tablist');
          this.insertBefore(this.tabList, this.source);
        }

        this.panels = [];
        this.tabs = [];

        parsed.groups.forEach((group, index) => {
          const panel = this.buildPanel(group, productTitle);
          this.appendIngredients(panel, group, ingredients);
          panel.hidden = index !== 0;
          this.insertBefore(panel, this.source);
          this.panels.push(panel);

          if (!showTabs) return;

          const tab = document.createElement('button');
          tab.type = 'button';
          tab.className = 'nutrition-facts__tab';
          tab.textContent = group.label || productTitle;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
          tab.addEventListener('click', () => this.select(index, 'smooth'));
          this.tabList.appendChild(tab);
          this.tabs.push(tab);
        });

        if (parsed.notes.length) {
          const notes = document.createElement('div');
          notes.className = 'prose nutrition-facts__notes';
          parsed.notes.forEach((node) => notes.appendChild(node));
          this.appendChild(notes);
        }

        if (ingredients.groups.length && ingredients.notes.length) {
          const notes = document.createElement('div');
          notes.className = 'prose nutrition-facts__notes nutrition-facts__ingredient-notes';
          ingredients.notes.forEach((node) => notes.appendChild(node));
          this.appendChild(notes);
        }
      }

      buildPanel(group, productTitle) {
        const panel = document.createElement('div');
        panel.className = 'nutrition-facts__panel';
        panel.setAttribute('role', 'tabpanel');
        panel.dataset.flavour = normalize(group.label);

        const card = document.createElement('div');
        card.className = 'nutrition-facts__card';
        panel.appendChild(card);

        if (group.label && productTitle) {
          const eyebrow = document.createElement('p');
          eyebrow.className = 'nutrition-facts__eyebrow';
          eyebrow.textContent = productTitle;
          card.appendChild(eyebrow);
        }

        const title = document.createElement('h3');
        title.className = 'nutrition-facts__title';
        title.textContent = group.label || productTitle || 'Nährwerte';
        card.appendChild(title);

        const primary = this.readTable(group.tables[0].table);

        if (primary.servingLabel) {
          const meta = document.createElement('p');
          meta.className = 'nutrition-facts__meta';
          const serving = /^\d/.test(primary.servingLabel)
            ? primary.servingLabel
            : '1 ' + primary.servingLabel;
          meta.innerHTML = '<strong>Portionsgröße:</strong> ' + serving;
          card.appendChild(meta);
        }

        if (primary.stats.protein) {
          const highlight = document.createElement('p');
          highlight.className = 'nutrition-facts__highlight';
          highlight.textContent =
            primary.stats.protein +
            ' Eiweiß' +
            (primary.servingShort ? ' pro ' + primary.servingShort : '');
          card.appendChild(highlight);
        }

        const statDefinitions = [
          ['protein', 'Eiweiß'],
          ['calories', 'Kalorien'],
          ['sugar', 'Zucker'],
        ].filter((entry) => primary.stats[entry[0]]);

        if (statDefinitions.length > 1) {
          const stats = document.createElement('div');
          stats.className = 'nutrition-facts__stats';
          statDefinitions.forEach((entry) => {
            const stat = document.createElement('div');
            stat.className = 'nutrition-facts__stat';
            const value = document.createElement('span');
            value.className = 'nutrition-facts__stat-value';
            value.textContent = primary.stats[entry[0]];
            const label = document.createElement('span');
            label.className = 'nutrition-facts__stat-label';
            label.textContent = entry[1];
            stat.appendChild(value);
            stat.appendChild(label);
            stats.appendChild(stat);
          });
          card.appendChild(stats);
        }

        group.tables.forEach((entry) => {
          if (entry.title) {
            const heading = document.createElement('h4');
            heading.className = 'nutrition-facts__table-title';
            heading.textContent = entry.title;
            card.appendChild(heading);
          }
          card.appendChild(this.buildTable(this.readTable(entry.table)));
        });

        return panel;
      }

      /* Reads a source table into header + rows, ignoring layout markup. */
      readTable(table) {
        const rows = Array.from(table.querySelectorAll('tr')).map((row) =>
          Array.from(row.children).map((cell) => clean(cell.textContent))
        );

        let header = null;
        let bodyRows = rows;

        if (rows.length) {
          const first = rows[0];
          const isHeader = first.some((cell) => /pro\s|100\s*g|%|portion/i.test(cell));
          if (isHeader) {
            header = first;
            bodyRows = rows.slice(1);
          }
        }

        bodyRows = bodyRows.filter((row) => row.some((cell) => cell !== ''));

        const valueIndex = header && header.length > 2 ? 2 : 1;
        const servingHeader = header ? header[valueIndex] || '' : '';
        const servingLabel = servingHeader
          ? servingHeader.replace(/^pro\s+/i, '').replace(/(\d)\s*g\)/i, '$1 g)')
          : '';
        const servingShort = servingLabel
          ? servingLabel.replace(/\s*\(.*\)\s*$/, '')
          : '';

        const findValue = (pattern) => {
          const row = bodyRows.find((cells) => pattern.test(cells[0] || ''));
          if (!row) return '';
          return row[valueIndex] || row[1] || '';
        };

        return {
          header: header,
          rows: bodyRows,
          servingLabel: servingLabel,
          servingShort: servingShort,
          stats: {
            protein: findValue(/eiwei|protein/i),
            calories: findValue(/kcal/i),
            sugar: findValue(/zucker/i),
          },
        };
      }

      buildTable(data) {
        const table = document.createElement('table');
        table.className = 'nutrition-facts__table';

        if (data.header) {
          const thead = document.createElement('thead');
          const row = document.createElement('tr');
          data.header.forEach((cell, index) => {
            const th = document.createElement('th');
            th.textContent = index === 0 ? cell || 'Nährwerte' : cell;
            row.appendChild(th);
          });
          thead.appendChild(row);
          table.appendChild(thead);
        }

        const tbody = document.createElement('tbody');
        data.rows.forEach((cells) => {
          const row = document.createElement('tr');
          const label = cells[0] || '';
          if (/^[-–•]\s*/.test(label) || /^davon/i.test(label)) {
            row.className = 'nutrition-facts__row--sub';
          }
          cells.forEach((cell, index) => {
            const td = document.createElement('td');
            td.textContent = index === 0 ? cell.replace(/^[-–•]\s*/, '') : cell;
            row.appendChild(td);
          });
          tbody.appendChild(row);
        });
        table.appendChild(tbody);

        return table;
      }

      select(index, behavior) {
        if (!this.panels || !this.panels[index]) return;
        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });
        if (this.tabs) {
          this.tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
          });
          this.centerActiveTab(behavior);
        }
      }

      /* Scrolls only the tab row (never the page) so the active flavour sits in the middle instead of at a cut-off edge. */
      centerActiveTab(behavior) {
        if (!this.tabList || !this.tabList.clientWidth) return;
        const tab = this.tabs.find((entry) => entry.getAttribute('aria-selected') === 'true');
        if (!tab) return;
        const list = this.tabList.getBoundingClientRect();
        const rect = tab.getBoundingClientRect();
        const offset = rect.left + rect.width / 2 - (list.left + list.width / 2);
        this.tabList.scrollTo({ left: this.tabList.scrollLeft + offset, behavior: behavior || 'auto' });
      }

      selectByOptions(optionsValue, behavior) {
        if (!optionsValue || !this.panels || this.panels.length < 2) return;

        const values = optionsValue.split('||').map(normalize).filter(Boolean);
        if (!values.length) return;

        const index = this.panels.findIndex((panel) => {
          const flavour = panel.dataset.flavour;
          if (!flavour) return false;
          return values.some(
            (value) =>
              value === flavour ||
              value.indexOf(flavour) !== -1 ||
              flavour.indexOf(value) !== -1
          );
        });

        if (index > -1) this.select(index, behavior);
      }
    }

    window.customElements.define('nutrition-facts', NutritionFacts);

    /* Opening the drawer resets the tab row's scroll position, so centre the active flavour again when it toggles.
       Delegated (capture, "toggle" does not bubble) because the drawer and its content can be swapped after load. */
    document.addEventListener(
      'toggle',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        target.querySelectorAll('nutrition-facts').forEach((facts) => {
          requestAnimationFrame(() => facts.centerActiveTab && facts.centerActiveTab());
        });
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-ugc-video-slider"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('ugc-video-slider')) {
    class UgcVideoSlider extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-ugc-scroller]');
        this.thumb = this.querySelector('[data-ugc-progress]');
        this.videos = Array.from(this.querySelectorAll('[data-ugc-video]'));
        this.onScroll = this.updateProgress.bind(this);
        this.onResize = this.updateProgress.bind(this);
        if (this.scroller) {
          this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize);
          this.updateProgress();
        }
        this.addEventListener('click', this.onClick);
        this.videos.forEach((video) => {
          video.addEventListener('ended', () => this.resetCard(video));
          video.addEventListener('pause', () => {
            if (video.currentTime === 0 || video.ended) this.resetCard(video);
          });
        });
      }

      disconnectedCallback() {
        if (this.scroller) this.scroller.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }

      updateProgress() {
        if (!this.scroller || !this.thumb) return;
        const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
        // no overflow (all cards fit) → nothing to scroll, hide the progress track
        this.thumb.parentElement.hidden = maxScroll <= 1;
        const ratio = this.scroller.scrollWidth > 0 ? this.scroller.clientWidth / this.scroller.scrollWidth : 1;
        const thumbWidth = Math.min(100, Math.max(18, ratio * 100));
        const progress = maxScroll > 0 ? this.scroller.scrollLeft / maxScroll : 0;
        this.thumb.style.width = thumbWidth + '%';
        this.thumb.style.marginLeft = progress * (100 - thumbWidth) + '%';
      }

      onClick(event) {
        const playButton = event.target.closest('[data-ugc-play]');
        const media = event.target.closest('.ugc-slider__media');
        if (!playButton && !media) return;
        const card = (playButton || media).closest('.ugc-slider__card');
        const video = card && card.querySelector('[data-ugc-video]');
        if (!video) return;
        event.preventDefault();
        if (card.classList.contains('is-playing') && !video.paused) {
          video.pause();
          this.resetCard(video);
          return;
        }
        this.playVideo(video);
      }

      playVideo(video) {
        this.videos.forEach((other) => {
          if (other !== video) {
            other.pause();
            this.resetCard(other);
          }
        });
        const card = video.closest('.ugc-slider__card');
        video.play().then(() => {
          if (card) card.classList.add('is-playing');
        }).catch(() => {});
      }

      resetCard(video) {
        const card = video.closest('.ugc-slider__card');
        if (card) card.classList.remove('is-playing');
      }
    }

    window.customElements.define('ugc-video-slider', UgcVideoSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["usp-list"] && !Shopify.designMode) return;
  try {
    /* Clickable USP badges: open the target accordion (<details is="accordion-disclosure">) and scroll to it.
     Delegated, so it keeps working when the product info is re-rendered (variant change, editor). */
  if (!window.evoUspBadgeLinks) {
    window.evoUspBadgeLinks = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-usp-target]');
      if (!trigger) return;
      const target = document.getElementById(trigger.getAttribute('data-usp-target'));
      if (!target) return;

      event.preventDefault();
      if (!target.open) target.open = true;

      /* scroll-padding on <html> keeps the summary clear of the sticky header */
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

      const summary = target.querySelector('summary');
      if (summary) summary.focus({ preventScroll: true });
    });

    /* keep aria-expanded of the badges in sync with their accordion ("toggle" does not bubble) */
    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.id) return;
        document.querySelectorAll('[data-usp-target]').forEach((trigger) => {
          if (trigger.getAttribute('data-usp-target') === details.id) {
            trigger.setAttribute('aria-expanded', details.open ? 'true' : 'false');
            trigger.classList.add('is-used'); /* no more simulated taps once it has been used */
          }
        });
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

})();
